<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    scrollable
    @input="changeDialog($event)">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mr-2"
        color="red"
        outlined
        v-bind="attrs"
        v-on="on">
        {{ $t('connector.shopee.btn.import') }}
      </v-btn>
    </template>
    <v-card
      class="app-card"
      tile>
      <v-toolbar
        flat
        dense>
        <title-label :label="$t('connector.shopee.importTitle')" />
        <v-spacer />
        <v-btn
          icon
          small
          @click="closeDialog()">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="shopeeProducts"
          :items-per-page="shopeeProducts.length"
          :loading="isFetching"
          item-key="code"
          class="app-table"
          height="500"
          fixed-header
          hide-default-footer />
        <div class="text-center">
          <v-btn
            v-if="hasMore && shopeeProducts.length >= pageSize"
            small
            :disabled="isFetching"
            @click="fetchMore()">
            โหลดข้อมูลเพิ่มเติม
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions class="grey lighten-5">
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          @click="closeDialog()">
          {{ $t('connector.shopee.btn.close') }}
        </v-btn>
        <save-change-button
          :state="state"
          :label="$t('connector.shopee.btn.importSelected')"
          :disabled="!hasSelected"
          @click="importData($event)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { GET_SHOPEEPRODUCTS, CREATE_SHOPEEPRODUCT } from '@/resources/graphql'

export default {
  apollo: {
    shopeeProducts: () => ({
      skip: true,
      fetchPolicy: 'no-cache',
      query: GET_SHOPEEPRODUCTS,
      variables () {
        return {
          page: 1,
          perPage: this.pageSize,
          stockId: this.itemStockId
        }
      },
      watchLoading (isLoading) {
        this.isFetching = isLoading
      }
    })
  },
  props: {
    itemStockId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      selected: [],
      shopeeProducts: [],
      page: 1,
      pageSize: 50,
      isFetching: false,
      state: 'ready',
      headers: [
        { text: this.$t('connector.shopee.table.header.productCode'), value: 'code', sortable: false },
        { text: this.$t('connector.shopee.table.header.productName'), value: 'name', sortable: false },
        { text: this.$t('connector.shopee.table.header.productPrice'), value: 'price', sortable: false },
        { text: this.$t('connector.shopee.table.header.productStock'), value: 'total', sortable: false }
      ],
      hasMore: true
    }
  },
  computed: {
    hasSelected () {
      return this.shopeeProducts.length > 0
    }
  },
  methods: {
    changeDialog (value) {
      this.$apollo.queries.shopeeProducts.skip = !value
      if (value) {
        this.$apollo.queries.shopeeProducts.refetch()
      }
    },
    closeDialog () {
      this.dialog = false
    },
    fetchMore () {
      this.page++
      this.$apollo.queries.shopeeProducts.fetchMore({
        variables: {
          page: this.page
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult || fetchMoreResult.shopeeProducts.length === 0) {
            this.hasMore = false
            return prev
          }
          return {
            shopeeProducts: [...prev.shopeeProducts, ...fetchMoreResult.shopeeProducts]
          }
        }
      })
    },
    async importData () {
      this.state = 'loading'
      const res = await this.$apollo.mutate({
        mutation: CREATE_SHOPEEPRODUCT,
        variables: {
          input: {
            id: Number(this.itemStockId)
          }
        }
      })

      if (res) {
        const { data: { shopeeImportProduct } } = res
        if (shopeeImportProduct.errors && Object.keys(shopeeImportProduct.errors).length) {
          this.state = 'error'
        } else {
          this.state = 'success'
          this.$apollo.queries.shopeeProducts.refetch()
        }
      }
    }
  }
}
</script>
